import {h, Fragment} from "preact"
import { useEffect, useState } from "preact/hooks"
import { useCurrencyFormatting } from "@nosto/preact";
import { usePromos } from "../../../hooks/usePromos"
import { useCustomConfig } from "../../../hooks/useCustomConfig"

const PriceFinal = ({ price }) => {
    return (
        <span class="final">
            <span class="visually-hidden">. Final price: </span>
            {price}
        </span>
    )   
}

const PriceCompare = ({ price }) => {
    return (
        <span class="compare">
            <span class="visually-hidden">. Original price: </span>
            {price}
        </span>
    )
}

const Promos = ({ promosHtml }) => {
    if (!promosHtml) return ''
    return (
        <div className="product-promos" dangerouslySetInnerHTML={{ __html: promosHtml }}></div>
    )
}

const SalePrice = ({ product, finalPrice, comparePrice }) => {
    return (
        <div class="price flex">
            <PriceFinal price={finalPrice} />
            {product.listPrice > product.price && <PriceCompare price={comparePrice} />}
        </div>
    )
}

const PromoPrice = ({ 
    product, 
    finalPrice, 
    comparePrice
}) => {

    const { 
        ref, 
        promosHtml,
        isProductPromo,
        isCollectionPromo
    } = usePromos({ product})

    return (
        <div className="price-info" ref={ref}>
            {promosHtml ? 
                <>
                    <div class="price flex">
                        {
                        isCollectionPromo ? 
                            <PriceCompare price={finalPrice} /> : 
                            <SalePrice product={product} finalPrice={finalPrice} comparePrice={comparePrice} />
                        }
                    </div>
                    <Promos promosHtml={promosHtml} />
                </> 
            : 
                <SalePrice product={product} finalPrice={finalPrice} comparePrice={comparePrice} />
            }
        </div>
    )
}

export default function Price({ product, enablePromos = false }) {
    
    const { customConfig } = useCustomConfig()

    const { format } = useCurrencyFormatting();
    const finalPrice = format(product.price)
    const comparePrice = format(product.listPrice)

    return (enablePromos && customConfig.cards.showPromotions ? 
        <PromoPrice product={product} finalPrice={finalPrice} comparePrice={comparePrice} /> : 
        (
            <div class="price flex">
                <PriceFinal price={finalPrice} />
                {product.listPrice > product.price && <PriceCompare price={comparePrice} />}
            </div>
        )
    )
}
